// Balcão / Totem — a implementação vive em features/totem/ (TotemApp). Este
// arquivo só mantém a rota do Dashboard apontando pro mesmo lugar.
import TotemApp from "../features/totem/TotemApp";

export default function BalcaoVendas(props) {
  return <TotemApp {...props} />;
}
